import { loadView } from '@/router'

export default [
  {
    path: 'carrier',
    name: 'billing-carrier',
    component: loadView('Application/Billing/CarrierInvoicesNew'),
    showInAlfred: true,
    alfredTitle: 'Billing - Carrier Invoices'
  },
  {
    path: 'carrier-old',
    name: 'billing-carrier-old',
    component: loadView('Application/Billing/CarrierInvoices')
  }
]
